import { useState } from 'react';
import Image from 'next/image';

export default function LazyYouTubeEmbed({
  videoId,
  title,
  width = 700,
  height = 400
}) {
  const [isPlayerActive, setPlayerActive] = useState(false);

  const w = typeof width === 'number' ? `${width}px` : width;
  const h = typeof height === 'number' ? `${height}px` : height;

  return (
    <div className="flex justify-center py-5">
      {isPlayerActive ? (
        <iframe
          width={w}
          height={h}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          className="rounded-lg shadow-md"
        />
      ) : (
        <div
          onClick={() => setPlayerActive(true)}
          className="relative cursor-pointer rounded-lg shadow-md overflow-hidden bg-black"
          style={{ width: w, height: h }}
          role="button"
          aria-label={`Play video: ${title}`}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setPlayerActive(true);
            }
          }}
        >
          <Image
            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
            alt={`Thumbnail of video: ${title}`}
            fill
            className="object-cover"
            sizes={`${width}px`}
            priority={false}
          />
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <svg
              className="w-16 h-16 text-white"
              fill="currentColor"
              viewBox="0 0 84 84"
              aria-hidden="true"
            >
              <circle cx="42" cy="42" r="42" fill="rgba(0,0,0,0.6)" />
              <polygon fill="white" points="33,24 65,42 33,60" />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}
